import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import dayjs from 'dayjs';
import { formatISODate, formatISOTime } from 'src/app/util/format-utils';
import { AssessmentScreenPartDateTime } from '@bluecrew/crew-member-backend-angular-client';
@Component({
  selector: 'app-screen-part-date-time',
  templateUrl: './screen-part-date-time.component.html',
  styleUrls: ['./screen-part-date-time.component.scss'],
})
export class ScreenPartDateTimeComponent implements OnInit {

  @Input() screenPart: AssessmentScreenPartDateTime;
  @Input() controlName: string;
  @Input() nextClicked?: boolean = false; // do not show errors when the value is empty if this is not passed in

  parentFormGroup: UntypedFormGroup;
  dateTimeFromPicker: string;

  constructor(private controlContainer: ControlContainer) { }

  ngOnInit() {
    // Set our form property to the parent control
    // (i.e. FormGroup) that was passed to us, so that our
    // view can data bind to it
    this.parentFormGroup = <UntypedFormGroup>this.controlContainer.control;
  }

  /**
   * Based on the screenPart's dateType, 
   * the ion-datetime will display different selectors.
   * 
   * @returns the date format the ion-datetime picker should display
   */
  getDatePickerDisplayFormat(): string {
    switch (this.screenPart.dateType) {
      case 'date':
        return 'MMM DD, YYYY';
      case 'time':
        return 'HH:mm';
      case 'date-time':
        return 'MMM DD, YYYY HH:mm';
    }
  }

  /**
   * 
   * @returns undefined if the dateWindow.start is null or undefined, 
   * since the ion-datetime component requires either 
   * an ISO 8601 date string or undefined
   */
  getMinDateWindow() {
    if (!this.screenPart.dateWindow?.start) {
      return undefined;
    }

    return this.screenPart.dateWindow.start;
  }

  /**
   * 
   * @returns undefined if the dateWindow.end is null or undefined, 
   * since the ion-datetime component requires either 
   * an ISO 8601 date string or undefined
   */
  getMaxDateWindow() {
    if (!this.screenPart.dateWindow?.end) {
      return undefined;
    }

    return this.screenPart.dateWindow.end;
  }

  /**
   * Since the ion-datetime picker always outputs an ISO 8601 date and time string
   * no matter the displayFormat setting, we need to format the output based 
   * on the screenPart's dateType and manually input it into the parent form
   * 
   * @param event the event emitted on ion-datetime picker change
   */
  setFormValue(event) {
    let formattedValue;
    const eventDateTime = dayjs(event.detail.value);
    switch (this.screenPart.dateType) {
      case 'date':
        formattedValue = formatISODate(eventDateTime);
        break;
      case 'time':
        formattedValue = formatISOTime(eventDateTime);
        break;
      case 'date-time':
        formattedValue = eventDateTime.toISOString();
        break;
    }
    this.parentFormGroup.get(this.controlName).setValue(formattedValue);
  }
}
